export const smartDocParamType_External = 'external';
export const smartDocExternalParamType_FreeText = 'free-text';
export const smartDocExternalParamType_NavigationResponse = 'navigation-response';
export const smartDocExternalParamType_Order = 'order';
export const smartDocExternalParamType_API = 'api';
export const smartDocExternalParamType = [
    smartDocExternalParamType_FreeText,
    smartDocExternalParamType_NavigationResponse,
    smartDocExternalParamType_Order,
    smartDocExternalParamType_API,
];
//# sourceMappingURL=types.js.map